import { useStaticQuery, graphql } from "gatsby"

export const useTeamImages = () => {
  const query = useStaticQuery(graphql`
    query {
      #OurTeam
      hero: file(
        relativePath: { eq: "img/Blog/our-team/fundacja-swiat-bez-barier.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      thumb: file(relativePath: { eq: "img/Blog/our-team/thumb.png" }) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      event: file(
        relativePath: { eq: "img/Blog/our-team/fundacja-swiat-bez-barier.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      #END
    }
  `)
  return query
}
